import { useEffect, useRef, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { GET_ALL_COUNTRY, GET_ALL_STATE_BY_COUNTY_ID, USER_REGISTER, fetchData } from "../../Service";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import Select from "react-select";
import { PhoneNumberUtil } from "google-libphonenumber";
import moment from "../../../../node_modules/moment/moment";
// import DatePicker from "react-multi-date-picker";

import "./CustomDatePicker.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";

import { Context } from "../../Context";
const phoneUtil = PhoneNumberUtil.getInstance();

const RegisterSocialMedia = () => {
	const [browser, setBrowser] = useState("");
	const [context, setContext] = useContext(Context);

	const [checkedItems, setCheckedItems] = useState([]);
	const [agree, setAgree] = useState(false);
	const [countryId, setCountryId] = useState();
	const [stateId, setStateId] = useState();
	const [country, setCountry] = useState([]);
	const [state, setState] = useState([]);
	const [fullPhone, setFullPhone] = useState("");
	const [selectedState, setSelectedState] = useState(null);
	const [selectedCountry, setSelectedCountry] = useState(null);
	const [dob, setDob] = useState(null);
	const [defaultPhoneCountry, setDefaultPhoneCountry] = useState("us");

	const getBrowser = () => {
		const userAgent = navigator.userAgent;
		if (userAgent.includes("Chrome")) return "Chrome";
		if (userAgent.includes("Firefox")) return "Firefox";
		if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) return "Safari";
		if (userAgent.includes("Edge")) return "Edge";
		if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) return "Internet Explorer";
		return "Unknown";
	};

	useEffect(() => {
		setBrowser(getBrowser());
	}, []);

	const isPhoneValid = (phone, country_code) => {
		try {
			// if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))) {
			// 	setError("mobile", { message: "Phone is invalid." });
			// 	setValue("mobile", "");
			// } else {
			// 	clearErrors("mobile");
			// 	setValue("mobile", phone);
			// }

			const onlyPhone = phone.replace(`+${country_code}`, "").trim();
			if (onlyPhone) {
				setValue("mobile", phone, { shouldValidate: true });
				clearErrors("mobile");
			} else {
				setValue("mobile", "");
				setError("mobile", { message: "Phone is required." });
			}
		} catch (error) {
			return false;
		}
	};

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		reset,
		clearErrors,
		setError,
		getValues,
	} = useForm({ mode: "onChange" });

	const areaOfInterest = [
		{ id: 0, name: "Real Estate" },
		{ id: 1, name: "Carpool" },
		{ id: 2, name: "Autos" },
		{ id: 3, name: "Movies/Videos" },
		{ id: 4, name: "Free Ads" },
		{ id: 5, name: "Student Talk" },
		{ id: 6, name: "Business Listing" },
	];

	const handleAreaOfinterest = (event) => {
		const { name, checked } = event.target;

		setCheckedItems((prevItems) => {
			if (checked) {
				const updatedItems = [...prevItems, name];
				console.log("Selected items:", updatedItems.join(","));
				return updatedItems;
			} else {
				const updatedItems = prevItems.filter((item) => item !== name);
				console.log("Selected items:", updatedItems.join(","));
				setCheckedItems(updatedItems);
				return updatedItems;
			}
		});
	};

	useEffect(() => {
		if (context.tempUserData) {
			setValue("first_name", context?.tempUserData?.given_name);
			setValue("last_name", context?.tempUserData?.family_name);
			setValue("email", context?.tempUserData?.email);
		}
	}, [context?.tempUserData?.email]);

	const handleStateChange = (selected) => {
		setSelectedState(selected);
		setValue("state_id", selected?.value, { shouldValidate: true });
	};

	const handleCountryChange = (selected) => {
		setSelectedCountry(selected);
		setValue("country_id", selected?.value, { shouldValidate: true });
		setCountryId(selected?.value);
		setSelectedState(null);
		setValue("state_id", "");

		country.forEach((item) => {
			if (item?.id == selected?.value) {
				setFullPhone("");
				setValue("mobile", "");
				setDefaultPhoneCountry(item?.code?.toLowerCase());
			}
		});
	};

	const getAllCountries = () => {
		fetchData(GET_ALL_COUNTRY, "GET", "", false, false, (res) => {
			if (res.status) {
				setCountry(res?.data);
			} else {
				setCountry([]);
			}
		});
	};

	const getAllStateByCountryId = (country_id) => {
		let value = {
			country_id: country_id,
		};

		fetchData(GET_ALL_STATE_BY_COUNTY_ID, "POST", value, false, false, (res) => {
			if (res.status) {
				setState(res?.data);
				setStateId(res?.data[0]?.id);
			} else {
				setState([]);
				setStateId();
			}
		});
	};

	const registerUser = (data) => {
		if (!agree) {
			setError("agree", { message: "Please accept terms and conditions." });
			return;
		}

		// Convert dob to a valid date format
		const dobFormatted = moment(data.dob, "YYYY-MM-DD");

		// Get today's date
		const today = moment().startOf("day"); // Ensures time doesn't affect comparison

		// Validate DOB (must not be greater than today)
		if (dobFormatted.isAfter(today)) {
			setError("dob", { message: "Date of birth cannot be in the future." });
			return;
		}

		data = {
			...data,
			is_active: false,
			area_interest: checkedItems.join(","),
			dob: dobFormatted.format("YYYY-MM-DD"),
			signup_type: "google",
		};

		fetchData(USER_REGISTER, "POST", data, false, false, (res) => {
			if (res.status) {
				toast.success("Registration successful");
				reset();
				setDob(null);
				setFullPhone("");
				setAgree(false);
				setCheckedItems([]);
				setValue("mobile", "");

				window.$("#signupSocialMediaModal").modal("hide");
			} else {
				toast.error(res?.message);
			}
		});
	};

	const gotoTerm = () => {
		window.open("/terms-and-conditions", "_blank");
	};

	useEffect(() => {
		getAllCountries();
	}, []);

	useEffect(() => {
		if (countryId) {
			getAllStateByCountryId(countryId);
		}
	}, [countryId]);

	return (
		<div
			className="modal fade pe-0"
			id="signupSocialMediaModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div className="modal-content apply-job-form">
					<button
						className="btn-close"
						onClick={() => {
							reset();
							setDob(null);
							setFullPhone("");
							setValue("mobile", "");
							setValue("dob", "");
							setValue("country_id", "");
							setValue("state_id", "");
							setSelectedState(null);
							setSelectedCountry(null);
						}}
						type="button"
						data-bs-dismiss="modal"
						aria-label="Close"
					></button>
					<div className="modal-header d-block text-center border-bottom-0">
						<a href="#!">
							<img title="NRIS" src="/assets/images/logo.png" width="150px" alt="..." />
						</a>
						<h5 className="text-brand-1 text-capitalize">Create Account</h5>
					</div>
					<div className="modal-body px-4 px-xl-5 py-3">
						<form className="login-register text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(registerUser)}>
							<div className="row">
								<div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
									<label>
										First Name <span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.first_name && "is-invalid"}`}
										maxLength={35}
										placeholder="First name"
										{...register("first_name", {
											required: {
												value: true,
												message: "First name is required.",
											},
											minLength: {
												value: 2,
												message: "First name is too short.",
											},
											maxLength: {
												value: 50,
												message: "First name is too long.",
											},
										})}
									/>
									{errors.first_name && <div class="invalid-feedback">{errors.first_name.message}</div>}
								</div>
								<div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
									<label>
										Last Name <span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.last_name && "is-invalid"}`}
										placeholder="Last name"
										maxLength={35}
										{...register("last_name", {
											required: {
												value: true,
												message: "Last name is required.",
											},
											minLength: {
												value: 2,
												message: "Last name is too short.",
											},
											maxLength: {
												value: 50,
												message: "Last name is too long.",
											},
										})}
									/>
									{errors.last_name && <div class="invalid-feedback">{errors.last_name.message}</div>}
								</div>
								<div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
									<label>
										Email <span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.email && "is-invalid"}`}
										disabled
										placeholder="Email"
										maxLength={120}
										type="email"
										{...register("email", {
											required: { value: true, message: "Email is required." },
											pattern: {
												value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
												message: "Email is invalid.",
											},
										})}
									/>
									{errors.email && <div class="invalid-feedback">{errors.email.message}</div>}
								</div>

								<div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
									<label>
										Date of Birth <span className="text-danger">*</span>
									</label>
									<div className="custom-datepicker-wrapper">
										{browser === "Safari" ? (
											<input
												type="date"
												className={`form-control bg-transparent ${errors.dob && "is-invalid"}`}
												onChange={(e) => {
													setDob(e.target.value);
													setValue("dob", e.target.value, {
														shouldValidate: true,
													});
												}}
												min={moment().subtract(100, "years").format("YYYY-MM-DD")}
												max={moment().format("YYYY-MM-DD")}
											/>
										) : (
											<DatePicker
												className={`form-control bg-transparent dp ${errors.dob && "is-invalid"}`}
												clearIcon={false}
												monthPlaceholder="MM"
												dayPlaceholder="DD"
												yearPlaceholder="YYYY"
												onChange={(date) => {
													setDob(date);
													setValue("dob", date, { shouldValidate: true });
												}}
												maxDate={new Date()}
												minDate={new Date("01-01-1900")}
												value={dob}
											/>
										)}
										{/* <DatePicker
                                            onChange={(date) => {
                                                setDob(date);
                                                setValue("dob", date, { shouldValidate: true });
                                            }}
                                            className={`${errors.dob && "bdr-red"}`}
                                            maxDate={new Date()}
                                            minDate={new Date("01-01-1900")}
                                            value={dob}
                                        /> */}
									</div>
									<input
										type="hidden"
										{...register("dob", {
											required: "Date of birth is required.",
										})}
									/>

									{errors.dob && <div class="invalid-feedback d-block">{errors.dob.message}</div>}
								</div>

								<div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
									<label>
										Country <span className="text-danger">*</span>
									</label>
									<Select
										options={country.map((item) => {
											return { label: item.name, value: item.id };
										})}
										isSearchable={false} 
										components={{ Input: () => null }}

										value={selectedCountry}
										onChange={handleCountryChange}
										placeholder="Select a country"
										className={`selectpicker p-0 ${errors.country_id && "is-invalid bdr-red"}`}
										classNamePrefix="react-select"
										styles={{
											menu: (provided) => ({
												...provided,
												maxHeight: "200px",
												overflowY: "auto",
												scrollbarWidth: "thin",
												msOverflowStyle: "none",
											}),
											menuList: (provided) => ({
												...provided,
												maxHeight: "200px",
												overflowY: "auto",
											}),
										}}
									/>

									{/* Hidden input for React Hook Form validation */}
									<input
										type="hidden"
										{...register("country_id", {
											required: "Country is required.",
										})}
									/>
									{errors.country_id && <div class="invalid-feedback d-block">{errors.country_id.message}</div>}
								</div>
								<div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
									<label>
										State <span className="text-danger">*</span>
									</label>
									<Select
										options={state.map((item) => {
											return { label: item.name, value: item.id };
										})}
										value={selectedState}
										onChange={handleStateChange}
										placeholder="Select a state"
										className={`selectpicker p-0 ${errors.state_id && "is-invalid bdr-red"}`}
										classNamePrefix="react-select"
										styles={{
											menu: (provided) => ({
												...provided,
												maxHeight: "200px",
												overflowY: "auto",
												scrollbarWidth: "thin",
												msOverflowStyle: "none",
											}),
											menuList: (provided) => ({
												...provided,
												maxHeight: "200px",
												overflowY: "auto",
											}),
										}}
									/>

									<input
										type="hidden"
										{...register("state_id", {
											required: "State is required.",
										})}
									/>
									{errors.state_id && <div class="invalid-feedback d-block">{errors.state_id.message}</div>}
								</div>
								<div className="col-xl-4 col-lg-4 col-sm-6 mb-2">
									<label>
										Phone <span className="text-danger">*</span>
									</label>
									<PhoneInput
										key={defaultPhoneCountry}
										defaultCountry={defaultPhoneCountry}
										forceDialCode={true}
										value={fullPhone}
										hideDropdown={true}
										disableCountryGuess={true}
										onChange={(phone, country) => {
											isPhoneValid(phone, country.country.dialCode);
											setFullPhone(phone);
											setValue("country_code", `+${country.country.dialCode}` || "+1");
										}}
										className={`form-control bg-transparent p-0 ${errors.mobile ? "is-invalid" : ""}`}
									/>
									<input
										type="hidden"
										{...register("mobile", {
											required: "Phone is required.",
										})}
									/>
									{errors.mobile && <div className="invalid-feedback">{errors.mobile.message}</div>}
								</div>
								<div className="col-12">
									<label>Area of interest</label>
									<div className="row">
										{areaOfInterest?.map((item) => (
											<div key={item.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
												<label className="cb-container">
													<input type="checkbox" name={item.name} onChange={(e) => handleAreaOfinterest(e)} checked={checkedItems.includes(item.name)} />
													<span className="color-black font12">{item.name}</span>
													<span className="checkmark"></span>
												</label>
											</div>
										))}
									</div>
								</div>
								<div className="col-12 mt-3">
									<label className="cb-container mb-0">
										<input
											type="checkbox"
											name="agree"
											{...register("agree", {
												required: "Please accept terms and conditions",
											})}
											checked={agree}
											onChange={(e) => {
												setAgree(e.target.checked);
												setValue("agree", e.target.checked, {
													shouldValidate: true,
												}); // Sync with React Hook Form
											}}
										/>

										<span className="checkmark"></span>
									</label>
									<span className="color-black font12 ms-4 ps-2">
										I agree to the{" "}
										<a href="#!" className="text-primary " onClick={gotoTerm}>
											terms and conditions
										</a>
									</span>
									{errors.agree && (
										<div
											style={{
												width: "100%",
												marginTop: ".25rem",
												fontSize: ".875em",
												color: "#dc3545",
											}}
										>
											{errors.agree.message}
										</div>
									)}
								</div>
							</div>
							<div className=" d-block text-center mt-2 mb-2">
								<button
									className={`btn btn-default hover-up m-auto 
                    `}
									type="submit"
									name="signup"
								>
									Sign Up
								</button>
							</div>
						</form>

						<p className="text-muted text-center">
							Already have an account?{" "}
							<a href="#!" className="text-primary " data-bs-toggle="modal" data-bs-target="#loginModal" data-bs-dismiss="modal">
								Sign In
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RegisterSocialMedia;
